import JohnsCreekHeroSection from "./components/HeroSection";
import JohnsCreekStickyNav from "./components/StickyNav";
import JohnsCreekProcessingTimeSection from "./components/ProcessingTimeSection";
import JohnsCreekServicesSection from "./components/ServicesSection";
import JohnsCreekLocalAreaSection from "./components/LocalAreaSection";
import JohnsCreekTestimonialsSection from "./components/TestimonialsSection";
import JohnsCreekAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import JohnsCreekComparisonSection from "./components/ComparisonSection";
import JohnsCreekMistakesSection from "./components/MistakesSection";
import JohnsCreekHowItWorksSection from "./components/HowItWorksSection";
import JohnsCreekFAQSection, { faqs } from "./components/FAQSection";
import JohnsCreekHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import JohnsCreekFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const faqsMapped = faqs.map((f: { q: string; a: string }) => ({ q: f.q, a: f.a }));

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function JohnsCreekPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Johns Creek"
        state="Georgia"
        stateAbbr="GA"
        route="/cities/johns-creek"
        title="Emergency Passport Johns Creek, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Johns Creek, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving north metro Atlanta travelers. Get your emergency passport fast!"
        geoPlacename="Johns Creek, Georgia"
        geoPosition="34.0289;-84.1986"
        faqs={faqsMapped}
        servicesSchema={servicesSchema}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
        keywords="expedited passport, emergency passport, Johns Creek passport, same day passport Atlanta, fast passport Georgia"
      />
      <JohnsCreekHeroSection />
      <JohnsCreekStickyNav />
      <JohnsCreekProcessingTimeSection />
      <JohnsCreekLocalAreaSection />
      <JohnsCreekServicesSection />
      <JohnsCreekTestimonialsSection />
      <JohnsCreekAcceptanceFacilitiesSection />
      <JohnsCreekComparisonSection />
      <JohnsCreekMistakesSection />
      <JohnsCreekHowItWorksSection />
      <JohnsCreekFAQSection />
      <JohnsCreekHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/johns-creek" state="GA" />
      <JohnsCreekFinalCTA />
    </div>
  );
}